const AREAS = {
  ARMERIA: 'Armería',
  EQUIPAMIENTO: 'Equipamiento',
  IFCSP: 'IFCSP',
  DESARROLLO_POLICIAL: 'Certificación policial',
  ENLACE_C3: 'Enlace C3',
  RECURSOS_HUMANOS: 'Recursos Humanos',
  REGISTRO_PERSONAL: 'Registro Personal',
  ENLACE_COMISARIA: 'Enlace Comisaría',
  EJECUTIVO: 'Ejecutivo',
}

export default AREAS
